import { mapState } from 'vuex'

import Camera from '~/components/mixins/aframe/Camera'
import Message from '~/components/mixins/aframe/Message'
import Reward from '~/components/mixins/aframe/Reward'
import Utility from '~/components/mixins/aframe/Utility'
import Wrapper from '~/components/mixins/aframe/Wrapper'
import Polygon from '~/components/mixins/aframe/Polygon'
import Cube from '~/components/mixins/aframe/Cube'
import Video from '~/components/mixins/aframe/Video'
import EnvMap from '~/components/mixins/aframe/EnvMap'
import CubeMapRealtime from '~/components/mixins/aframe/Cubemap-Realtime'
import Portal from '~/components/mixins/aframe/Portal'
import { gaEvent } from '~/plugins/gtagGA4'
// import Videosphere from '~/components/mixins/aframe/Videosphere'

export default {
  mixins: [
    Camera,
    Message,
    Reward,
    Utility,
    Wrapper,
    Polygon,
    Cube,
    Video,
    EnvMap,
    CubeMapRealtime,
    Portal
    // Videosphere
  ],
  computed: {
    ...mapState({
      cubeAnimation: 'cubeAnimation',
      camera: state => state.drop.camera,
      wrapper: state => state.drop.droplet,
      track: state => state.drop.track,
      preMessage: state => state.drop.preMessage,
      messageProps: state => state.drop.messageProps,
      localPolygon: state => state.localPolygon,
      polygon: state => state.drop.polygon,
      rewards: state => state.drop.rewards,
      reward: state => state.drop.reward,
      video: state => state.drop.video,
      portal: state => state.drop.portal
    })
  },
  created () {
    // adds the event listener function that will handle the event
    this.$nuxt.$on('actionClick', (action) => {
      const link = action.link
      // if link has https:// then navigate there
      // otherwise if link it another drop id, load that drop
      debugger
      if (action.link && (/(https):\/\//i.test(link))) {
        // TODO install https://google-analytics.nuxtjs.org/setup
        // gtag('event', 'actionLink', {
        //   dropId: this.$route.params,
        //   event_category: 'Drops',
        //   event_label: action.link
        // })
        window.open(link, '_blank')
      } else if (action.drop && action.drop !== '') {
        this.actionDrop(action.drop)
      } else if (action.play && action.play !== '') {
        this.actionPlay(action.play)
      } else if (action.video && action.video !== '') {
        this.actionVideo(action.video)
      }
      const actionType = action.link ? 'link' : action.drop ? 'drop' : action.play ? 'play' : action.video ? 'video' : 'unknown'
      gaEvent({ event: 'action_click', value: actionType })
    })

    this.$nuxt.$on('nextScene', () => {
      document.querySelector('#opening').setAttribute('visible', false)
      document.querySelector('#dropscene').setAttribute('visible', true)
      document.querySelector('[polygon]').setAttribute('class', 'clickable')
      document.querySelector('[wrapper]').removeAttribute('class')

      // rewards
      this.updateClickable()

      gaEvent({ event: 'scene_drop' })
    })

    // WIP
    // if (window.XR8 && window.XRExtras) {
    //   console.log('XR8', window.XR8)
    // //   const AudioContext = (window.AudioContext || window.webkitAudioContext)
    // //   const el = document.getElementById('audio')
    // //   const source = context.createMediaElementSource(el)
    // }
  },
  methods: {
    aframeComponents () {
      this.cameraComponents()
      this.utilityComponents()
      this.messageComponents()
      this.rewardComponents()
      this.wrapperComponents()
      if (this.polygon) {
        this.polygonComponents()
      }
      this.cubeComponents()
      this.videoComponents()
      // TODO: figure out way to inject these only when needed.
      this.envMap()
      if (this.portal && this.portal.visible) {
        this.cubeMapRealtime() // this is specific to portal atm
        this.portalComponents()
      }

      // this.videosphereComponents()
      this.$nuxt.$on('actionClick', (action) => {
        // debugger
        // this.testKey = action.link
        this.$forceUpdate()
      })
    },
    actionPlay (track) {
      try {
        debugger
        console.log('play', track)
        this.$store.commit('track', track)
      } catch (err) {

      }
    },
    actionVideo (video) {
      const videoElement = document.querySelector('video')
      if (videoElement.paused) {
        videoElement.play()
      } else {
        videoElement.pause()
      }
    },
    async actionDrop (dropId) {
      try {
        debugger
        // unload
        const response = await this.$axios.get(`/pub/drop/${dropId}`)
        this.$store.commit('drop', response.data)
      } catch (err) {
        // console.log(err)
      }
    },
    beforeDestroy () {
      debugger
      // TODO test me!
      const polygonComponent = document.querySelector('[polygon]')
      if (polygonComponent) { this.dispose(polygonComponent) }
      const wrapperComponent = document.querySelector('[wrapper]')
      if (wrapperComponent) { this.dispose(wrapperComponent) }

      // resetting here as a ductape fix. in /blank it's happening too late and can cause an error
      this.$store.commit('resetDropState')
    },
    dispose (component) {
      const mesh = component.getObject3D('mesh')
      const cleanMaterial = (material) => {
        // console.log('dispose material!')
        material.dispose()

        // dispose textures
        for (const key of Object.keys(material)) {
          const value = material[key]
          if (value && typeof value === 'object' && 'minFilter' in value) {
            // console.log('dispose texture!')
            value.dispose()
          }
        }
      }

      if (mesh) {
        mesh.traverse((object) => {
          if (!object.isMesh) { return }

          // console.log('dispose geometry!')
          if (object.geometry) { object.geometry.dispose() }
          if (object.texture) { object.texture.dispose() }
          if (object.material.isMaterial) {
            cleanMaterial(object.material)
          } else {
            // an array of materials
            for (const material of object.material) {
              cleanMaterial(material)
            }
          }
        })
      }
      const audioElement = document.getElementById('audio')
      const videoElement = document.getElementById('video')

      if (audioElement) {
        audioElement.pause()
        audioElement.removeAttribute('src') // empty source
        audioElement.load()
      }
      if (videoElement) {
        videoElement.pause()
        videoElement.removeAttribute('src') // empty source
        videoElement.load()
      }

      // TODO AnimationMixer.
      // if component has animation mixer
      debugger
      if (component.hasAttribute('animation-mixer')) {
        const mixerEntity = document.querySelector('[animation-mixer]')
        mixerEntity.pause()
        // const test = mixerEntity.getRoot()
        // const clip = root.animations[0]

        // component.removeAttribute('animation-mixer')

        // // stop action
        // mixer.stopAllAction()
        // mixer.uncacheClip(clip)
        // mixer.uncacheRoot(root)

        // unclip...https://threejs.org/docs/#api/en/animation/AnimationMixer
      }

      component.removeObject3D('mesh')
      // delete components;

      window.THREE.Cache.clear()
      const scene = AFRAME.scenes[0]
      scene.renderer.renderLists.dispose()
      scene.renderer.info.reset()
    }
  }
}
